<template lang="pug">
div.small-margin
  b-switch.is-small(:value="table.hasHeadline" @input="e => updateConfigValue('headline', e)") Überschrift
  b-switch.is-small(:value="table.hasColors" @input="e => updateConfigValue('colors', e)") Abwechselnde Farben
  b-switch.is-small(:value="table.isMiddle" @input="e => updateConfigValue('middle', e)") Mittig ausrichten
  b-switch.is-small(:value="table.hasBigMargin" @input="e => updateConfigValue('margin', e)") Großer Abstand
  b-switch.is-small(:value="table.isResponsive" @input="e => updateConfigValue('mobile', e)") Spezielle Mobile Ansicht 
  
  .spacer.sm
  b-button.is-success.is-small(icon-left="plus" @click="addRow()") Zeile
  .spacer.inline.sm
  b-button.is-gray.is-small(v-if="table.body[0].length > 1" icon-left="minus" @click="deleteRow()") Zeile
  .spacer.inline
  b-button.is-success.is-small(icon-left="plus" @click="table.body.push([''])") Spalte
  .spacer.inline.sm
  b-button.is-gray.is-small(v-if="table.body.length > 1" icon-left="minus" @click="table.body.pop()") Spalte
  .spacer.sm
  
  table
    thead
      tr
        th(v-for="col in table.body.length")
          b-input(:value="table.head[col - 1]" @input="e => updateValue(null, col - 1, e)")
    tbody
      tr(v-for="row in table.body[0].length")
        td(v-for="col in table.body.length")
          b-input(:value="table.body[col - 1][row - 1]" @input="e => updateValue(row - 1, col - 1, e)")
</template>

<script>
export default {
  components: {

  },
  props: {
    parentKey: String,
    initBlock: {
      type: Object,
      default() {
        return {
          value: {
            table: {
              hasHeadline: false,
              hasColors: false,
              isMiddle: false,
              isResponsive: false,
              hasBigMargin: false,
              head: [""],
              body: [
                [""]
              ]
            }
          },
          config: null
        }
      }
    }
  },
  data() {
    return {
      table: {
        hasHeadline: false,
        hasColors: false,
        isMiddle: false,
        isResponsive: false,
        hasBigMargin: false,
        head: [""],
        body: [
          [""]
        ]
      }
    };
  },
  methods: {
    addRow() {
      for (let i = 0; i < this.table.body.length; i++) {
        this.table.body[i].push("");
      }
    },
    deleteRow() {
      for (let i = 0; i < this.table.body.length; i++) {
        this.table.body[i].pop();
      }
    },
    updateConfigValue(what, e) {
      switch (what) {
        case "headline":
          this.table.hasHeadline = e;
          break;
        case "colors":
          this.table.hasColors = e;
          break;
        case "middle":
          this.table.isMiddle = e;
          break;
        case "mobile":
          this.table.isResponsive = e;
          break;
        case "margin":
          this.table.hasBigMargin = e;
          break;
      }
      
      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          table: this.table
        }
      });
    },
    updateValue(row, col, e) {
      if (row !== null) {
        this.table.body[col][row] = e;
      } else {
        this.table.head[col] = e;
      }
      
      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          table: this.table
        }
      });
    }
  },
  mounted() {
    if (this.initBlock.value.table) {
      this.table = JSON.parse(JSON.stringify(this.initBlock.value.table));
    }
  }
}
</script>

<style lang="scss" scoped>
.small-margin {
  margin-top: 16px;
  margin-bottom: 16px;
}
table {
  thead {
    border-bottom: solid 4px $primary;
  }
}
</style>